import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import config from "../config";
import { message } from "antd";
import { postApi,baseURL} from '../components/Utility'
import {
  action,
  
  makeObservable,
  observable,
 
} from 'mobx';


class EventReportStore {
  eventReport=[]
  total=0
  loading=false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
        eventReport: observable,
      total:observable,
      loading:observable,
      loadData:action,
      exportExcel:action,
      exportpdf:action,
      exportcsv:action,
      exportxml:action
    });
     this.rootStore = rootStore;
    
  }

  async loadData({offset,limit,companyId,eventCode,fromDate,toDate,vehicleId,pageNo}) {
    this.loading=true;
    // console.log("event Report")
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"eventCode":eventCode,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":pageNo}
    // postData.companyId=10166
    // postData.vehicleId=27043

    if(config.pythonReport == 1){
        var response = await postApi.getClient('report').post("/report/event", postData);
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=vehicle&a=eventreport", "postData="+base64Input);
    }   
    this.eventReport =response?.data?.data?.eventreport
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;
  }

  async exportExcel(getData) {

    if(config.pythonReport == 1){

        getData = { ...getData, language: "english", colList: getData.colList.replace(',ViewOnMap', '') }
        // getData = { ...getData, companyId: 10166 }
        // getData = { ...getData, vehicleId: 27043 }
        try {
            var response = await postApi.getClient("report").post("/report/event/download/excel", getData, {
                responseType: "blob",
            });
        
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
        
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Event Report.xlsx";
        
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
      
        } catch (error) {
            message.error("Failed to download the report. Please try again.")
        }

    }else{
    // console.log("getData", getData);
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exporteventexcel&cid=" +
          getData.companyId +
          "&vid=" +
          getData.vehicleId +
          "&eventCode=" +
          getData.eventCode +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }

  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){
        getData = { ...getData, language: "english", colList: getData.colList.replace(',ViewOnMap', '') }
        // getData = { ...getData, companyId: 10166 }
        // getData = { ...getData, vehicleId: 27043 }
        try {
            var response = await postApi.getClient("report").post("/report/event/download/pdf", getData, {
                responseType: "blob",
            });
        
            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });
        
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Event Report.pdf";
        
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            message.error("Failed to download the report. Please try again.")
        }
    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exporteventpdf&cid=" +
          getData.companyId +
          // " &userId=" +
          // 1 +
          "&vid=" +
          getData.vehicleId +
          // "&int=" +
          // getData.interval +
          "&eventCode=" +
          getData.eventCode +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;

    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exporteventcsv&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.interval +
      "&eventCode=" +
      getData.eventCode +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exporteventxml&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.interval +
      "&eventCode=" +
      getData.eventCode +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  

  
  

}

export default EventReportStore;
